export default "__VITE_ASSET__d2605f87__"